import React from 'react';

import './AuErrorText.scss';

interface Props {
  text: string;
  className?: string;
  dark?: boolean;
  inline?: boolean;
  style?: React.CSSProperties;
}

const setInnerHTML = (value) => {
  return { __html: value };
};

/**
 * DEFAULT
 * The error text component
 */
const AuErrorText: React.FC<Props> = ({ text, dark, inline, className = '' }) => (
  <span className={
    `au-error-text ${ className }` +
    `${ dark ? ' au-error-text--dark' : '' }` +
    `${ inline ? ' au-error-text--inline' : '' }`
  }
  dangerouslySetInnerHTML={setInnerHTML(text)}
  >
  </span>
);

export default AuErrorText;